"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildTrialState = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var isExpired = function isExpired(removedAt) {
  var now = _I18n.default.moment().valueOf();

  return removedAt && removedAt < now;
};

var buildTrialState = function buildTrialState(createdAt, endsAt, removedAt, id) {
  return {
    inTrial: !isExpired(removedAt) ? {
      createdTs: createdAt,
      expiresTs: endsAt
    } : null,
    hasTrialed: isExpired(removedAt) ? {
      lastTrialStarted: createdAt,
      lastTrialExpired: removedAt
    } : null,
    id: id
  };
};

exports.buildTrialState = buildTrialState;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/core/utilities/trialUtils.js
// module id = 766
// module chunks = 5 6